































import { computed, defineComponent, PropType, watch } from '@nuxtjs/composition-api'

import useSearchFilter from '@/composables/use-search-filter'

import SearchFilter from '@/classes/SearchFilter'
import CustomSelectItem from '@/interfaces/CustomSelectItem'

export default defineComponent({
  props: {
    value: {
      type: SearchFilter,
      default: (): SearchFilter => new SearchFilter(),
    },
    priceRangeMinMax: {
      type: Array as unknown as PropType<[number, number] | null>,
      default: null,
    },
    availableBrands: {
      type: Array as PropType<CustomSelectItem['value'][]>,
      default: () => [],
    },
    availableCarTypes: {
      type: Array as PropType<CustomSelectItem['value'][]>,
      default: () => [],
    },
  },
  setup (props, { emit }) {
    const {
      ageRange,
      priceRange,
      oneWayRental,
      acceptForeigner,
      brands,
      carTypes,
      paymentMethods,
      storeServices,
      equipments,
      filter,
      clear: clearFilter,
    } = useSearchFilter()

    watch(
      () => props.value,
      (value) => { filter.value = value.clone() },
      { immediate: true }
    )

    const save = () => emit('input', filter.value.clone())

    const clear = () => {
      clearFilter()
      save()
    }

    const isMoreActive = computed(() => {
      const { value } = props
      return value.isCarTypesActive ||
        value.isPriceRangeActive ||
        value.isStoreServicesActive ||
        value.isEquipmentsActive
    })

    return {
      ageRange,
      priceRange,
      oneWayRental,
      acceptForeigner,
      brands,
      carTypes,
      paymentMethods,
      storeServices,
      equipments,

      filter,

      save,
      clear,

      isMoreActive,
    }
  },
})
